import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { ROUTE_PATH } from '../../../../config/paths';
import RouteDeleteButton from './RouteDeleteButton';

const RouteToolbar = ({ routeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${ROUTE_PATH}/${routeId}/edit`} />{' '}
      <RouteDeleteButton routeId={routeId} />
    </div>
  </ButtonToolbar>
);

RouteToolbar.propTypes = {
  routeId: PropTypes.number.isRequired,
};

export default RouteToolbar;
